import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Stack, Text, TextLink } from '@stepstone-genesis/components';
import { Trans } from '@stepstone-platform/i18n';
import { languageSpecificConfigSelector } from '../../../../core/siteConfig/siteConfigSlice.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { trackButtonClick } from '../../../../tracking/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../twoStepLoginRegistrationSlice.js';
const TERM_OF_USE = 'terms-of-use-link';
const PROTECTION_POLICY = 'data-protection-link';
export const TwoStepConsent = ({ label, variant }) => {
    const { dataProtectionPolicyUrl, termsOfUseUrl } = useAppSelector(languageSpecificConfigSelector);
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const dispatch = useAppDispatch();
    const onTermsOfUseClick = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'termsOfUse',
            componentState,
        }));
    };
    const onDataProtection = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'dataProtection',
            componentState,
        }));
    };
    return (_jsx(Stack, { direction: "vertical", "data-testid": `two-step-${variant}-consent-container`, children: _jsx(Text, { size: 'xs', color: 'colorGreyDark', lineHeight: "lineHeightXs", children: _jsx(Trans, { i18nKey: label, components: [
                    _jsx(TextLink, { "data-testid": TERM_OF_USE, variant: "bare", href: termsOfUseUrl, onClick: onTermsOfUseClick }, TERM_OF_USE),
                    _jsx(TextLink, { "data-testid": PROTECTION_POLICY, variant: "bare", href: dataProtectionPolicyUrl, onClick: onDataProtection }, PROTECTION_POLICY),
                ] }) }) }));
};
//# sourceMappingURL=TwoStepConsent.js.map